export var ShadowCascadesMode;
(function (ShadowCascadesMode) {
    ShadowCascadesMode[ShadowCascadesMode["NoCascades"] = 0] = "NoCascades";
    ShadowCascadesMode[ShadowCascadesMode["TwoCascades"] = 1] = "TwoCascades";
    ShadowCascadesMode[ShadowCascadesMode["FourCascades"] = 2] = "FourCascades";
})(ShadowCascadesMode || (ShadowCascadesMode = {}));
